import React from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { ComprehensiveAssessment, idgLcdString, idgPgbaString } from '@mummssoftware/utils/constants';
import { ChangesReviewedDiv, CompAssessmentTitleP, FlexDiv, FontBoldSpan, IDGMeetingPrintPreviewDiv, TableOfContentsDiv, TableOfContentsTitleP, TextCenterDiv } from './styled-divs/PrintPreviewStyledDivs';
import messages from '../PatientHeader/messages';

var _ref = /*#__PURE__*/React.createElement(TextCenterDiv, null, /*#__PURE__*/React.createElement(CompAssessmentTitleP, null, "COMPREHENSIVE ASSESSMENT / POC"));

var _ref2 = /*#__PURE__*/React.createElement(TextCenterDiv, null, /*#__PURE__*/React.createElement(TableOfContentsTitleP, null, "Table of Contents:"));

var _ref3 = /*#__PURE__*/React.createElement(FontBoldSpan, null, "I.");

var _ref4 = /*#__PURE__*/React.createElement(FontBoldSpan, null, "II.");

var _ref5 = /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FontBoldSpan, null, "III."), " Vitals signs and other indicators of patient decline.");

var _ref6 = /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FontBoldSpan, null, "IV."), " A review of all changes to the patient POC occurring since admit or last IDG meeting.");

var _ref7 = /*#__PURE__*/React.createElement(ChangesReviewedDiv, null, /*#__PURE__*/React.createElement("p", null, "These changes reviewed include:"), /*#__PURE__*/React.createElement("p", null, "a) Medications"), /*#__PURE__*/React.createElement("p", null, "b) CP Visit Frequencies"), /*#__PURE__*/React.createElement("p", null, "c) CP Problems, Goals, & Interventions"));

var _ref8 = /*#__PURE__*/React.createElement(FlexDiv, null, /*#__PURE__*/React.createElement("p", null, "The patient's current POC, resulting from the above changes is also presented here"));

var _ref9 = /*#__PURE__*/React.createElement("div", null);

export const IDGMeetingCoverPage = ({
  allIdgQuestionnaires,
  currentUser,
  idgMeetingContent
}) => {
  const {
    formatMessage
  } = useIntl();

  if (allIdgQuestionnaires && allIdgQuestionnaires.length > 0 && idgMeetingContent && idgMeetingContent.to && idgMeetingContent.from) {
    let closestVisitDateLcdForm;
    let closestCreationDateLcdForm;
    let closestVisitDateCAForm;
    let closestCreationDateCAForm;
    const compAssessments = allIdgQuestionnaires.filter(questionnaire => questionnaire.formname === ComprehensiveAssessment);
    const idgLcdForms = allIdgQuestionnaires.filter(questionnaire => questionnaire.formkey === idgLcdString || questionnaire.formkey === idgPgbaString);
    /* 
    loops through all SUBMITTED idg-lcd forms and sets closestVisitDateLcdForm to idg-lcd form with visitdatetime 
    field closest to today as well as closestCreationDateLcdForm to idg-lcd with closest createdatetime to today 
    (createdate is fallback if visitdate isn't available) 
    */

    let cachedDiff = Infinity;
    let secondaryCachedDiff = Infinity;
    idgLcdForms && idgLcdForms.length > 0 && idgLcdForms.forEach(form => {
      const visitDateDiff = form.visitdatetime && moment().diff(moment(form.visitdatetime), 'seconds');

      if (typeof visitDateDiff === 'number' && visitDateDiff > 0 && visitDateDiff < cachedDiff) {
        cachedDiff = visitDateDiff;
        closestVisitDateLcdForm = form;
      }

      const createDateDiff = form.createdatetime && moment().diff(moment(form.createdatetime), 'seconds');

      if (typeof createDateDiff === 'number' && createDateDiff > 0 && createDateDiff < secondaryCachedDiff) {
        secondaryCachedDiff = createDateDiff;
        closestCreationDateLcdForm = form;
      }
    });
    /* same thing as above, just with Comprehensive Assessment forms */

    let thirdCachedDiff = Infinity;
    let fourthCachedDiff = Infinity;
    compAssessments && compAssessments.length > 0 && compAssessments.forEach(form => {
      const visitDateDiff = form.visitdatetime && moment().diff(moment(form.visitdatetime), 'seconds');

      if (typeof visitDateDiff === 'number' && visitDateDiff > 0 && visitDateDiff < thirdCachedDiff) {
        thirdCachedDiff = visitDateDiff;
        closestVisitDateCAForm = form;
      }

      const createDateDiff = form.createdatetime && moment().diff(moment(form.createdatetime), 'seconds');

      if (typeof createDateDiff === 'number' && createDateDiff > 0 && createDateDiff < fourthCachedDiff) {
        fourthCachedDiff = createDateDiff;
        closestCreationDateCAForm = form;
      }
    });
    const idgFromDate = moment(idgMeetingContent.from);
    const idgToDate = moment(idgMeetingContent.to);
    const lcdVisitBetweenIdgToFrom = closestVisitDateLcdForm && moment(closestVisitDateLcdForm.visitdate).isBetween(idgFromDate, idgToDate, undefined, '[]');
    const lcdCreateBetweenIdgToFrom = closestCreationDateLcdForm && moment(closestCreationDateLcdForm.createdate).isBetween(idgFromDate, idgToDate, undefined, '[]');
    const caVisitBetweenIdgToFrom = closestVisitDateCAForm && moment(closestVisitDateCAForm.visitdate).isBetween(idgFromDate, idgToDate, undefined, '[]');
    const caCreateBetweenIdgToFrom = closestCreationDateCAForm && moment(closestCreationDateCAForm.createdate).isBetween(idgFromDate, idgToDate, undefined, '[]');

    const createPersonString = form => {
      const {
        createpersonfirstname,
        createpersonlastname,
        createpersoncredentials
      } = form;
      return `${createpersonfirstname} ${createpersonlastname} ${createpersoncredentials}`;
    };

    const visitDateCAFormValid = closestVisitDateCAForm && caVisitBetweenIdgToFrom;
    const creationDateCAFormValid = closestCreationDateCAForm && caCreateBetweenIdgToFrom;
    const visitDateLcdFormValid = closestVisitDateLcdForm && lcdVisitBetweenIdgToFrom;
    const creationDateLcdFormValid = closestCreationDateLcdForm && lcdCreateBetweenIdgToFrom;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IDGMeetingPrintPreviewDiv, null, _ref, /*#__PURE__*/React.createElement(TableOfContentsDiv, null, _ref2, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, _ref3, " Comprehensive Assessment done by", ' ', visitDateCAFormValid && createPersonString(closestVisitDateCAForm) || creationDateCAFormValid && createPersonString(closestCreationDateCAForm) || formatMessage(messages.naAcronym), ' ', "on", ' ', visitDateCAFormValid && moment(closestVisitDateCAForm.visitdate).format('L') || creationDateCAFormValid && moment(closestCreationDateCAForm.createdate).format('L') || formatMessage(messages.naAcronym), "."), /*#__PURE__*/React.createElement("p", null, _ref4, " LCD documentation done by", ' ', visitDateLcdFormValid && createPersonString(closestVisitDateLcdForm) || creationDateLcdFormValid && createPersonString(closestCreationDateLcdForm) || formatMessage(messages.naAcronym), ' ', "on", ' ', visitDateLcdFormValid && moment(closestVisitDateLcdForm.visitdate).format('L') || creationDateLcdFormValid && moment(closestCreationDateLcdForm.createdate).format('L') || formatMessage(messages.naAcronym), "."), _ref5, _ref6), _ref7, _ref8)));
  }

  return _ref9;
};